module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/step3_bg_left-a89f8e9ed4bcdc053f879e9c2e38ffbd.png";